export default [
  {
    path: '/basic-settings',
    name:'basic-settings',
    component: () => import('@/views/settings/BasicSettings.vue'),
    meta: { 
      title:'Connect to Amazon',
      requiresAuth: true 
    },
  },
  {
    path: '/amazon-business-auth/callback',
    name: 'auth-callback',
    component: () => import('@/views/settings/AuthCallback.vue'),
    meta: { 
      title:'Connect to Amazon',
      requiresAuth: true 
    },
  }
]